export default {"src":"/_next/static/media/document-award.5f3d3a78.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};